import { useState, useEffect } from "react";
import { progressAPI } from "../services/api";
import { PageWrapper, Card, Logo } from "../components";
import { Flame, Check } from "lucide-react";

export const ProgressPage = () => {
  const [progress, setProgress] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProgress = async () => {
      try {
        const res = await progressAPI.getOverview();
        setProgress(res.data);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    fetchProgress();
  }, []);

  if (loading) {
    return (
      <PageWrapper>
        <div className="flex items-center justify-center h-64">
          <div className="animate-pulse-gentle text-[#4A6741]">Loading...</div>
        </div>
      </PageWrapper>
    );
  }

  return (
    <PageWrapper>
      <div className="p-6 space-y-6 max-w-lg mx-auto">
        {/* Header with Logo */}
        <div className="flex items-center justify-center">
          <Logo size="md" variant="dark" />
        </div>

        <div className="space-y-1">
          <h1 className="font-heading text-3xl text-[#292524]">Your Progress</h1>
          <p className="text-[#78716C]">Celebrate your journey</p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 gap-4">
          <Card className="p-5 text-center animate-fade-in-up">
            <div className="w-12 h-12 bg-[#D4A373]/10 rounded-full flex items-center justify-center mx-auto mb-3">
              <Flame className="text-[#D4A373]" size={24} />
            </div>
            <p className="font-heading text-3xl text-[#292524]">{progress?.streak || 0}</p>
            <p className="text-sm text-[#78716C]">Day Streak</p>
          </Card>
          <Card className="p-5 text-center animate-fade-in-up stagger-1">
            <div className="w-12 h-12 bg-[#4A6741]/10 rounded-full flex items-center justify-center mx-auto mb-3">
              <Check className="text-[#4A6741]" size={24} />
            </div>
            <p className="font-heading text-3xl text-[#292524]">{progress?.total_completed || 0}</p>
            <p className="text-sm text-[#78716C]">Lessons Completed</p>
          </Card>
        </div>

        {/* Timeline */}
        <div className="space-y-3">
          <h2 className="font-heading text-xl text-[#292524]">Recent Activity</h2>
          {progress?.recent_events?.length > 0 ? (
            <div className="space-y-3">
              {progress.recent_events.map((event, idx) => (
                <Card key={event.id} className={`p-4 flex items-center gap-4 animate-fade-in-up stagger-${idx + 1}`}>
                  <div className="w-10 h-10 bg-[#4A6741]/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <Check className="text-[#4A6741]" size={20} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="font-medium text-[#292524] truncate">{event.lesson_title}</p>
                    <p className="text-sm text-[#78716C]">{event.program_title}</p>
                  </div>
                  <p className="text-xs text-[#78716C]">
                    {new Date(event.completed_at).toLocaleDateString()}
                  </p>
                </Card>
              ))}
            </div>
          ) : (
            <Card className="p-8 text-center">
              <p className="text-[#78716C]">No activity yet. Start your first lesson!</p>
            </Card>
          )}
        </div>
      </div>
    </PageWrapper>
  );
};
